// extracted by mini-css-extract-plugin
export var actionButton = "_sg-0";
export var actionMenuContainer = "_sg-i";
export var bubble = "_sg-2";
export var bubbleActionMenu = "_sg-j";
export var bubbleContext = "_sg-6";
export var bubbleItems = "_sg-7";
export var customer = "_sg-3";
export var divider = "_sg-8";
export var fileList = "_sg-9";
export var hiddenComment = "_sg-o";
export var infoAbove = "_sg-a";
export var internal = "_sg-4";
export var lightActionButton = "_sg-1";
export var link = "_sg-b";
export var merchant = "_sg-5";
export var message = "_sg-c";
export var profilePicture = "_sg-e";
export var quillToolbarContainer = "_sg-f";
export var senderDate = "_sg-g";
export var senderDateCustomer = "_sg-h";
export var senderName = "_sg-d";
export var time = "_sg-k";
export var uploadedImage = "_sg-l";
export var username = "_sg-m";
export var xsmall = "_sg-n";